import './header.css'
import {FiGithub, FiLinkedin} from 'react-icons/fi';
import { IconContext } from 'react-icons';

const Header = () => {
  let location = "https://www.google.com/maps/place/Brownsville,+TX/@26.0291269,-97.5991777,11z/data=!3m1!4b1!4m5!3m4!1s0x866f7f6bc3fc6519:0xb1df1a694856522c!8m2!3d25.9017472!4d-97.4974838";
  let uni = "https://www.utdallas.edu/";
  let resume = "https://docs.google.com/document/d/e/2PACX-1vQIzFYUOKKm5CHA9a_kAuABY9lZF9VV26xsgxFk67YKW9umG0tkAx-X5LzOtBgpKbQiOTWpFxmdphBe/pub";

  return (
    <div>
    <div className="container-header">
        <p className='txt'><span>&#128075;</span> Hello my name is</p>
        <h1 className='name'>Gabriel Anguiano<span className='dot'>.</span></h1>
        <p className='txt'>I'm a human from <a className='anchor dot' href={location} target="_blank" rel="noopener noreferrer">Brownsville, Texas</a> who loves learning new technologies, video-games, anime, & music.</p>
        <p className='txt'>I'm currently a student at <a className='anchor dot' href={uni} target="_blank" rel="noopener noreferrer"> UT Dallas </a> 
        looking for an internship to grow as a Software Engineer. 
        You can find my <a className='anchor dot' href={resume} target="_blank" rel="noopener noreferrer">resume here</a>.</p>
    </div>
    <div className='icons'>
    <IconContext.Provider value={{className: 'react-icons', size: '2rem'}}>
        <a href="https://github.com/ShifuX"><FiGithub /></a>
        <a href="https://www.linkedin.com/in/gabriel-anguiano13"><FiLinkedin /></a>
    </IconContext.Provider>
    </div>
    </div>
  )
}

export default Header